// ─────────────────────────────────────────────────────────────────
// Glass-i — Fixed Assets grid columns (Stage 6B.9D).
//
// Columns: # / Asset Code / Asset Name / Category / Ledger /
//          Purchase Date / Cap Date / Original Cost / Accum Depr /
//          WDV / Status / Actions
// ─────────────────────────────────────────────────────────────────

import { Tag, Tooltip } from 'antd';
import { formatINR } from '../../../../components/common/erp-grid';
import {
  STATUS_COLOR, STATUS_LABEL, calculateWdv
} from './fixedAssetsHelpers';

function fmtDate(v) {
  return v ? String(v).slice(0, 10) : <span className="erp-grid__muted">—</span>;
}

export function buildFixedAssetsColumns({ currentPage, pageSize } = {}) {
  return [
    { title: '#', key: '__sno__', width: 56, align: 'center', fixed: 'left',
      render: (_v, _r, idx) => {
        const cp = Number(currentPage) > 0 ? Number(currentPage) : 1;
        const ps = Number(pageSize)    > 0 ? Number(pageSize)    : 25;
        return (cp - 1) * ps + idx + 1;
      } },
    { title: 'Asset Code', dataIndex: 'assetCode', key: 'assetCode',
      width: 160, sorter: true, filter: true,
      render: (v) => (v ? <code className="erp-grid__code">{v}</code> : <span className="erp-grid__muted">—</span>) },
    { title: 'Asset Name', dataIndex: 'assetName', key: 'assetName',
      sorter: true, filter: true,
      render: (v) => v || <span className="erp-grid__muted">—</span> },
    { title: 'Category', dataIndex: 'categoryName', key: 'categoryName',
      width: 160, filter: true,
      render: (v) => v || <span className="erp-grid__muted">—</span> },
    { title: 'Asset Ledger', key: 'assetLedger', width: 220,
      render: (_v, row) => row.assetLedgerCode
        ? <span>
            <code className="erp-grid__code" style={{ marginRight: 6 }}>{row.assetLedgerCode}</code>
            {row.assetLedgerName}
          </span>
        : <span className="erp-grid__muted">—</span> },
    { title: 'Purchase Date', dataIndex: 'purchaseDate', key: 'purchaseDate',
      width: 120, sorter: true, render: fmtDate },
    { title: 'Cap. Date', dataIndex: 'capitalizationDate', key: 'capitalizationDate',
      width: 120, sorter: true, render: fmtDate },
    { title: 'Original Cost', dataIndex: 'originalCost', key: 'originalCost',
      width: 130, sorter: true, align: 'right',
      render: (v) => `₹ ${formatINR(Number(v) || 0)}` },
    { title: 'Accum. Depr.', dataIndex: 'accumulatedDepreciation', key: 'accumulatedDepreciation',
      width: 130, sorter: true, align: 'right',
      render: (v) => `₹ ${formatINR(Number(v) || 0)}` },
    { title: 'WDV', key: 'wdv', width: 130, align: 'right',
      render: (_v, row) => `₹ ${formatINR(calculateWdv(row))}` },
    { title: 'Status', dataIndex: 'status', key: 'status', width: 110,
      filter: true, sorter: true,
      render: (v) => v
        ? <Tag color={STATUS_COLOR[v] || 'default'}>{STATUS_LABEL[v] || v}</Tag>
        : <span className="erp-grid__muted">—</span> }
  ];
}
